"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const recoil_1 = require("recoil");
const reportElementTypes_1 = require("../../../domain/reportElementTypes");
const reportListItemProps_1 = require("../../../domain/reportListItemProps");
const FoldersRoute_1 = __importDefault(require("../../../routes/FoldersRoute"));
const ReportsRoute_1 = __importDefault(require("../../../routes/ReportsRoute"));
const folder_1 = require("../../../server/models/folder");
const ReportViewToggle_1 = require("../shared/ReportViewToggle");
const useCurrentFolder = ({ folderId, handleErrorsCallback, }) => {
    const isMounted = (0, react_1.useRef)(true);
    const [isFetchingFolder, setIsFetchingFolder] = (0, react_1.useState)(true);
    const [currentFolder, setCurrentFolder] = (0, react_1.useState)(undefined);
    const [folders, setFolders] = (0, react_1.useState)([]);
    const [dashboards, setDashboards] = (0, react_1.useState)([]);
    const [looks, setLooks] = (0, react_1.useState)([]);
    const setCount = (0, recoil_1.useSetRecoilState)(ReportViewToggle_1.recordCountTableState);
    const updateCurrentFolder = async (res) => {
        if (isMounted.current) {
            try {
                const [folders, dashboards, looks] = await Promise.all([
                    (0, folder_1.getFolderChildrenSummaries)({ page: 1, perPage: 30 }, folderId),
                    res?.dashboards.length ? (0, folder_1.getFolderDashboardsFor)(folderId) : [],
                    res?.looks.length ? (0, folder_1.getFolderLooksFor)(folderId) : [],
                ]);
                setFolders(folders?.map((folder) => {
                    return new reportListItemProps_1.ReportListItemProps({
                        ...folder,
                        basePath: `${FoldersRoute_1.default.path}/${folder.id}`,
                        elementType: reportElementTypes_1.ReportElementTypes.Folder,
                        dashboards: folder.dashboards?.length,
                        looks: folder.looks?.length,
                        createdBy: folder.createdBy,
                        folder: folder.name,
                        folderId: folder.id,
                    });
                }) ?? []);
                setDashboards(dashboards?.map((dashboard) => {
                    return new reportListItemProps_1.ReportListItemProps({
                        ...dashboard,
                        elementType: reportElementTypes_1.ReportElementTypes.Dashboard,
                        basePath: `${ReportsRoute_1.default.path}/${dashboard.folder.id}?dashboardId=${dashboard.id}`,
                        dashboards: 0,
                        looks: 0,
                        createdBy: dashboard.userName,
                        name: dashboard.title,
                        folder: dashboard.folder.name,
                        folderId: dashboard.folder.id,
                    });
                }) ?? []);
                setLooks(looks?.map((look) => {
                    return new reportListItemProps_1.ReportListItemProps({
                        ...look,
                        elementType: reportElementTypes_1.ReportElementTypes.Look,
                        basePath: `${ReportsRoute_1.default.path}/${look.folder.id}?lookId=${look.id}`,
                        dashboards: 0,
                        looks: 0,
                        createdBy: look.userName,
                        name: look.title,
                        folder: look.folder.name,
                        folderId: look.folder.id,
                    });
                }) ?? []);
                setCurrentFolder(res);
                setIsFetchingFolder(false);
            }
            catch (err) {
                handleErrorsCallback(err);
            }
        }
    };
    const getCurrentFolder = (0, react_1.useCallback)(() => {
        setIsFetchingFolder(true);
        setCount(0);
        (0, folder_1.getFolderFor)(folderId)
            .then(updateCurrentFolder)
            .catch(handleErrorsCallback);
    }, [folderId]);
    (0, react_1.useEffect)(() => {
        isMounted.current = true;
        getCurrentFolder();
        return () => {
            isMounted.current = false;
        };
    }, [getCurrentFolder]);
    return [isFetchingFolder, currentFolder, folders, dashboards, looks];
};
exports.default = useCurrentFolder;
